var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAdminB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.561,
    height: 30.561
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-admin-B_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4358",
    d: "M0 0h26.129v16.787h-13.4V30H0z",
    transform: "translate(4842 2194)",
    fill: "none",
    stroke: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2186",
    transform: "translate(-4842 -2194)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 167",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4848.5 2201h13"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 168",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4848.5 2205h7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 98",
    transform: "translate(4856 2212)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4.75
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 169",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4863.5 2219.5l4 4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 15",
    clipPath: "url(#icon-admin-B_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 359",
    transform: "translate(4845 2197)",
    fill: "none",
    stroke: "#00b8f1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 21.5,
    height: 25.5,
    rx: 1.25
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 99",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(4865 2210)",
    fill: "#00b8f1"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 100",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(4854 2221)",
    fill: "#00b8f1"
  }))));
}

export default SvgIconAdminB;